import { IngredientRequest } from '@app/models/feed_exp_ingredients/IngredientRequest';
import {
  IngredientTableData,
  IngredientTableRow,
  IngredientApiData,
  Parameters,
  ExpIngredientResponse,
} from '@app/models/feed_exp_ingredients/IngredientResponse';
import { post, get } from './http.api';

export const getIngredientData = async (parameters: Parameters): Promise<IngredientTableData> => {
  try {
    const { data, status } = await get<any>(
      'feed_expected_ingredients',
      {
        params: parameters,
      },
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    const expIngredients: IngredientTableRow[] = data.pr_feed_expected_ingredients.data.map((feedData: any) => ({
      id: feedData.id,
      year: feedData.year,
      status: feedData.status,
    }));

    return {
      data: expIngredients,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Expected Ingredients:', error);
    throw error;
  }
};

export const getAllExpIngredients = async (): Promise<ExpIngredientResponse> => {
  try {
    const { data, status } = await get<ExpIngredientResponse>(`feed_expected_ingredients`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getIngredientById = async (id: number): Promise<ExpIngredientResponse> => {
  try {
    const { data, status } = await get<ExpIngredientResponse>(`feed_expected_ingredients/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeIngredient = async (feedData: IngredientRequest) => {
  try {
    const response = await post<any>('feed_expected_ingredients/create', feedData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createIngredient = async (): Promise<IngredientApiData> => {
  try {
    const { data, status } = await get<IngredientApiData>(`feed_expected_ingredients/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showIngredient = async (id: number) => {
  try {
    const { data, status } = await get<IngredientApiData>(`feed_expected_ingredients/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editIngredient = async (id: number) => {
  try {
    const { data, status } = await get<IngredientApiData>(`feed_expected_ingredients/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateIngredient = async (id: number, UpdateFeed: IngredientRequest) => {
  try {
    const { data, status } = await post<IngredientRequest>(
      `feed_expected_ingredients/${id}/edit`,
      UpdateFeed,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
